// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ChevronRightOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 320 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M310.6 233.4a32.05 32.05 0 010 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"}}]},"name":"chevron-right","theme":"outlined"};

const ChevronRightOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ChevronRightOutlinedSvg} />;
  ChevronRightOutlined.displayName = 'ChevronRightOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ChevronRightOutlined);
